import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { deliveryLabel, deliveryDate } from "@/lib/metaUtil";
import { FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import VersatileLink from "@/components/VersatileLink";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";

export default function EpisodeListCard({ item }) {
  const channelId = Number(item?.channel?.id);
  const showValuePlanLabel = isShowValuePlanLabel({ channelId });

  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      className={classnames(styles.container, styles.list, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={routes.watchWithRtsid(item)}
            linkAttr={{ onClick: handleClick }}
            showValuePlanLabel={showValuePlanLabel}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <VersatileLink
              onClick={handleClick}
              href={routes.watchWithRtsid(item)}
            >
              {item.name}
            </VersatileLink>
          </h4>
          <div className={styles.delivery}>
            <div className={styles.deliveryItem}>
              <span>{deliveryLabel(item)}</span>{" "}
              <span>{deliveryDate(item)}</span>
            </div>
            <div className={styles.tags}>
              <span>{item.genres.map((genre) => genre.name).join("/")}</span>
              {item.production_year && <span>{item.production_year}</span>}
              {item.duration && <span>{Math.floor(item.duration / 60)}分</span>}
            </div>
          </div>
          <p className={styles.description}>{item.description}</p>
        </div>
        <div>
          <FavoriteButton listRow metaId={item.id} />
        </div>
      </div>
    </div>
  );
}
